import { render, staticRenderFns } from "./selectDealer.vue?vue&type=template&id=a045d89a&scoped=true&"
import script from "./selectDealer.vue?vue&type=script&lang=js&"
export * from "./selectDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a045d89a",
  null
  
)

export default component.exports